// Maťa:
// Dočasné pomocné funkce pro pro vyhodnocení práv na prvcích
// Použito jen zpětnou kompatibilitu
// Až se vyhodnocování práv předelá tak tento soubor smazat
import { IOWObject } from "OW.Remoting/Remoting/DataTypes/IOWObject";
import { NullOWObject } from "../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { OWManager } from "../../../OW.Remoting/Remoting/OWManager";
import { RequestContext } from "../../../OW.Remoting/Remoting/RequestContext";
import { ClassItemRightTypes, IClassItem as ClassItem } from "../../../OW.Remoting/Remoting/Rights";
import { IClassItemRights } from "./IClassItemRights";
// TODO-rites: tato funkce by už neměla být potřeba - vyhodit
export async function getClassItemsRights(obj: IOWObject, classItems: ClassItem[], requestContext?: RequestContext, evaluateWithoutAO?: boolean): Promise<Map<string, IClassItemRights>> {
    const result: Map<string, IClassItemRights> = new Map();
    if (classItems && classItems.length > 0) {
        const promises: Promise<IClassItemRights>[] = [];
        if (!(!obj || obj instanceof NullOWObject) || evaluateWithoutAO) {
            for (const itemRightsReq of classItems)
                promises.push(obj ? obj.itemRights(itemRightsReq.name, itemRightsReq.type, ClassItemRightTypes.all, requestContext?.cancellationToken) : OWManager.staticMethodsRights(itemRightsReq.name, requestContext));
        }
        const items: IClassItemRights[] = await Promise.all(promises);
        for (const item of items)
            result.set(item.Name, item);
    }
    return result;
}
